module.exports = __webpack_public_path__ + "img/cart-blue-circle.712f1213.svg";